import { Button, Divider, NumberKeyboard, PasscodeInput } from "antd-mobile";
import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";

export default function Workstation(props) {

    const { setWorkStation = () => { }, logout = () => { }, session = {} } = props;
    const [code, setCode] = useState("");
    const ref = useRef();
    const current = session.available_corps.find(a => a.id == window.credentials.store_id);

    useEffect(() => {
        setTimeout(() => {
            if(ref?.current){
                ref.current.focus();
            }
        }, 600)
    }, [])


    const handleInput = (key) => {
        if (code.length < 2) {
            setCode((prev) => prev + key);
        }
    };

    const handleDelete = () => {
        setCode((prev) => prev.slice(0, -1));
    };

    const handleKeyDown = (e) => {
        if (e.key >= '0' && e.key <= '9') {
            handleInput(e.key);
        } else if (e.key === 'Backspace') {
            handleDelete();
        } else if (e.key === '+' || e.key === '-') {
            handleInput(e.key);
        }
    };

    const changeLocation = () => {
        window.history.replaceState(null, '', '/');
        window.location.reload();
    }

   
    


    return (
        <>
            <div className="shim" />
            <span className="dim">Enter Workstation:</span>
            <br /><div className="shim" />
            <big>{current?.name}</big>
            <div onKeyDown={handleKeyDown} style={{ "padding": "30px", "paddingTop": "20px" }}>
                <PasscodeInput
                    value={code}
                    onChange={(e) => setCode(e)}
                    plain={true} ref={ref} length={2} keyboard={<NumberKeyboard showCloseButton={false} />} />
                <div className="shim" /> <div className="shim" /> <div className="shim" />
                <Button disabled={!code} onClick={() => setWorkStation(code, current.id)} color={(code) ? "primary" : "default"} block>Continue</Button>
            </div>
            <Divider><a onClick={() => changeLocation()}>Change Location</a></Divider>
        </>
    )
}